
class MicrophonePermissionHandler {
  // Requires HTTPS secure context
    async getPermission() {
      return new Promise((resolve) => {
        try {
          navigator.mediaDevices
            .getUserMedia({ video: false, audio: true })
            .then((stream) => {
              resolve({ stream: stream, error: null });
            })
            .catch((error) => {
              resolve({ stream: null, error: error });
            });
        }
        catch(error) {
          resolve({ stream: null, error: error });
        }
      })
    }
};

export default MicrophonePermissionHandler;
